module.exports = __webpack_public_path__ + "img/icon-goal-3.ef96f330.svg";